var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['c-character', { '-modal' : this.modal }],style:({ 'background-image': ("url(" + _vm.image + ")") }),attrs:{"data-cy":"c-character","src":_vm.image,"alt":_vm.description,"title":_vm.description}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58d6c524","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CCharacter.vue
// module id = 2192
// module chunks = 1611